import React, { useContext, useState } from 'react';
import { isExtensionInstalled } from '../../utils/tiptap';
import EditorHighlightColor from '@wix/da-ds/pkg/Icons/24x24/EditorHighlightColor';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
import { TOOLTIP_HOVER_DELAY } from '../../../constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import ColorPicker from '../../lego/ColorPicker';
import s from './buttons.scss';
const offsetModifier = [
    0,
    6
];
const FontHighlight = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const [open, setOpen] = useState(false);
    const isMobile = useContext(MobileContext);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'textHighlight')) {
        return null;
    }
    const button = /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: EditorHighlightColor,
        // reusing textAlign here as its the same logic and means we don't need to dupe the tiptap exts
        disabled: !editor.can().chain().focus().setTextAlign('center').run(),
        featureId: "format:highlight",
        onClick: ()=>{
            setOpen(!open);
        },
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        tooltipText: t('button.fontbackground.tooltip'),
        "aria-label": t('button.fontbackground.tooltip')
    });
    const content = /*#__PURE__*/ React.createElement(ColorPicker, {
        value: editor.getAttributes('highlight').color,
        onChange: (value)=>{
            editor.chain().setHighlight({
                color: value
            }).run();
        },
        onRemove: ()=>{
            editor.chain().unsetHighlight().run();
        }
    });
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, button, /*#__PURE__*/ React.createElement(ModalRoot, {
            className: s['color-modal'],
            isFullscreen: false,
            isOpen: open,
            hasCloseButton: false,
            shouldCloseOnOverlayClick: true,
            onRequestClose: ()=>{
                setOpen(false);
            }
        }, content));
    }
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: content,
        placement: "top",
        isVisible: open,
        offsetModifier: offsetModifier,
        onClickOutside: ()=>{
            setOpen(false);
        }
    }, button);
};
FontHighlight.displayName = 'FontHighlight';
export default FontHighlight;

//# sourceMappingURL=FontHighlight.js.map